<template>
    <div class="transitions-actions">
        <CustomSelect
            v-model="selected"
            :form-value-text="({ label }) => label"
            :options="actions"
            paginate
            :paginate-amount="100"
            with-filter
            width="100%"
            @update:model-value="onSelect"
        >
            <template #default="{ item: { label } }">
                {{ label }}
            </template>
        </CustomSelect>
    </div>
</template>

<script>
import { CustomSelect } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'TransitionsActions',
    components: {
        CustomSelect,
    },
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selected: null,
        };
    },
    methods: {
        onSelect(event) {
            this.$emit('selected', event);
        },
    },
};
</script>

<style src="./TransitionsActions.scss" lang="scss"></style>
